import React from "react";
import { Link } from "wouter";

type VideoCardProps = {
  videoId: string;
  title: string;
  description: string;
  href: string;
  className?: string;
};

export function VideoCard({ videoId, title, description, href, className }: VideoCardProps) {
  return (
    <Link
      href={href}
      aria-label={`${title} tool page`}
      className={`group block overflow-hidden rounded-xl border border-white/10 bg-white/[0.035] transition-colors duration-200 hover:border-cyan-300/35 hover:bg-white/[0.055] ${className ?? ""}`}
    >
      <div className="relative aspect-video overflow-hidden bg-[#080F1A]">
        <img
          className="h-full w-full object-cover opacity-80 transition-opacity duration-200 group-hover:opacity-100"
          src={`https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`}
          alt=""
          loading="lazy"
        />
        <span className="absolute inset-0 bg-gradient-to-t from-[#080F1A]/65 via-transparent to-[#080F1A]/10" aria-hidden="true" />
        <span className="absolute inset-0 flex items-center justify-center" aria-hidden="true">
          <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-[#33CDD3] text-[#080F1A] shadow-lg">
            <svg viewBox="0 0 24 24" className="ml-0.5 h-5 w-5 fill-current" focusable="false">
              <path d="M8 5.5v13l10-6.5-10-6.5Z" />
            </svg>
          </span>
        </span>
      </div>
      <div className="p-4">
        <h3 className="text-base font-bold text-white">{title}</h3>
        <p className="mt-1 line-clamp-1 text-sm leading-6 text-slate-400" title={description}>{description}</p>
      </div>
    </Link>
  );
}
